import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError';
import { PatientsApi } from '../../../apis/PatientsApi/PatientsApi';

export function useUpdateFileNumberMutation(patientId?: string) {
    if (!patientId)
        throw new Error('useUpdateFileNumberMutation requires a valid patientId');

    const queryClient = useQueryClient();

    return useMutation<boolean, AppMedError, string | null, unknown>({
        mutationKey: [QueryKeys.fileNumber, patientId],
        mutationFn: async (fileNumber: string | null) => {
            return await PatientsApi.updateFileNumber(patientId, fileNumber);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.patientProfileSummary, patientId] });
        },
    });
}
